import React from "react";

export const GroupTitle = ({ number, title }) => {
  return (
    <div className="col-12">
      <div className="eb_fs_16 row">
        <div className="headingPrint">
          <span className="number">{number}</span>
          <b>{title}</b>
        </div>
      </div>
    </div>
  );
};
